"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var IUnderlinedTextRender = (function (_super) {
    __extends(IUnderlinedTextRender, _super);
    function IUnderlinedTextRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IUnderlinedTextRender;
}(zebra.ui.TextRender));
exports.IUnderlinedTextRender = IUnderlinedTextRender;
exports.underlinedTextRender = zebra.Class(zebra.ui.TextRender, [
    function paintLine(g, x, y, line, d) {
        this.$super(g, x, y, line, d);
        g.setColor(this.color);
        g.drawLine(x, y + this.getLineHeight() - 1, x + this.lineWidth(line), y + this.getLineHeight() - 1);
    }
]);
//# sourceMappingURL=underlinedTextRender.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/uiElements/underlinedTextRender.js
// module id = 31
// module chunks = 0